/* eslint-disable */
// @ts-nocheck
import { EmojiIndex } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import data from 'emoji-mart-vue-fast/data/all.json';

export type Emoji = {
  colons: string;
  short_names: string[];
  name: string;
  text: string;
  emoticons: string[];
  keywords: string[];
  imageUrl?: string;
  native?: string;
};

//keeping a sample as comment for future use

const teachinomojis: Emoji[] = [
  {
    colons: ':onenote:',
    short_names: ['onenote'],
    name: 'OneNote',
    text: 'OneNote',
    emoticons: [],
    keywords: ['onenote'],
    imageUrl: '/emoji/teachinomoji/onenote.png',
  },
  {
    colons: ':onedrive:',
    short_names: ['onedrive'],
    name: 'OneDrive',
    text: 'OneDrive',
    emoticons: [],
    keywords: ['onedrive'],
    imageUrl: '/emoji/teachinomoji/onedrive.png',
  },
];

const recentemojis = [
  'pencil2',
  'lower_left_fountain_pen',
  'lower_left_paintbrush',
  'speech_balloon',
  'speaker',
  'straight_ruler',
  'scissors',
  'hammer_and_wrench',
  'carpentry_saw',
  'page_facing_up',
  'closed_book',
  'book',
  'books',
  'ledger',
  'spiral_note_pad',
  'memo',
  'clipboard',
  'alarm_clock',
  'mega',
  'dart',
  'point_up',
  'point_right',
  'pushpin',
  'paperclip',
  'bellhop_bell',
  'x',
  'question',
  'exclamation',
  'bangbang',
  'warning',
  'no_entry_sign',
  'top',
  'heavy_plus_sign',
  'hourglass',
  'brain',
  'musical_note',
  'headphones',
  'desktop_computer',
  'printer',
  'tv',
  'camera',
  'arrow_left',
  'arrow_right',
  'arrow_down',
  'arrow_up',
  'one',
  'two',
  'three',
  'four',
  'five',
  'white_check_mark',
  'red_circle',
  'large_orange_circle',
  'large_yellow_circle',
  'large_green_circle',
  'large_blue_circle',
  'large_purple_circle',
  'de',
  'us',
  'fr',
  'it',
  'gb',
  'flag-au',
];

// exclude dangerous emojis
// https://hot.miss.at/sex-emojis-diese-symbole-sind-ziemlich-zweideutig/
const blackList = ['fist', 'peach', 'eggplant', 'sweat_drops'];

export const emojiIndex = new EmojiIndex(data, {
  custom: teachinomojis,
  recentLength: 20,
  include: [
    'recent',
    'smileys',
    'people',
    'nature',
    'foods',
    'activity',
    'places',
    'objects',
    'symbols',
    'flags',
    'custom',
  ],
  exclude: [],
  native: true,
  sheetSize: 64,
  emojisToShowFilter: (emoji: Emoji) => {
    return (
      blackList.filter(
        (short_name) => emoji.short_names.indexOf(short_name) > -1,
      ).length === 0
    );
  },
  recent: recentemojis,
});

export function findEmoji(emojiId?: string): Emoji | null {
  const teachinomoji = teachinomojis.find((tmoji) =>
    tmoji.short_names.includes(emojiId ?? ''),
  );
  if (teachinomoji) return teachinomoji;
  try {
    return emojiIndex.findEmoji(emojiId);
  } catch (e) {
    return null;
  }
}
